// extracted by mini-css-extract-plugin
export default {"wrapper":"PatientDetails_wrapper__dM8d+","row":"PatientDetails_row__GqcHi"};